/* ============================================
   SHAGGY GOLF - THEME JS
============================================ */

// Mobile Menu Toggle
function toggleMobileMenu() {
  const nav = document.getElementById('mobile-nav');
  const hamburger = document.getElementById('hamburger');
  if (nav && hamburger) {
    nav.classList.toggle('open');
    hamburger.classList.toggle('active');
    document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
  }
}

// Cart Count Update
function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const countEl = document.getElementById('cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    })
    .catch(() => {});
}

// Add to Cart via AJAX
function addToCart(variantId, quantity = 1) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(res => res.json())
  .then(data => {
    updateCartCount();
    showCartNotification(data.title);
    return data;
  })
  .catch(err => console.error('Add to cart error:', err));
}

// Cart Notification
function showCartNotification(productName) {
  let notification = document.getElementById('cart-notification');
  if (!notification) {
    notification = document.createElement('div');
    notification.id = 'cart-notification';
    notification.style.cssText = `
      position: fixed;
      top: 80px;
      right: 20px;
      background: #1D9E75;
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 4px;
      font-family: 'Montserrat', sans-serif;
      font-size: 0.9rem;
      font-weight: 600;
      z-index: 9999;
      box-shadow: 0 4px 20px rgba(0,0,0,0.2);
      transform: translateX(120%);
      transition: transform 0.3s ease;
    `;
    document.body.appendChild(notification);
  }

  notification.textContent = `✓ ${productName} added to cart!`;
  notification.style.transform = 'translateX(0)';
  setTimeout(() => {
    notification.style.transform = 'translateX(120%)';
  }, 3000);
}

// Cart Quantity Change
function changeCartQty(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  })
  .then(res => res.json())
  .then(() => {
    updateCartCount();
    window.location.reload();
  })
  .catch(err => console.error('Cart change error:', err));
}

// Remove Cart Item
function removeCartItem(key) {
  changeCartQty(key, 0);
}

// Quantity Selectors
document.addEventListener('DOMContentLoaded', function () {

  // Update cart count on load
  updateCartCount();

  // Product page qty buttons
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.product-qty-wrap, .cart-qty-wrap')
        ?.querySelector('.qty-input, .cart-qty-input');
      if (!input) return;
      const current = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus' && current > 1) input.value = current - 1;
      if (this.dataset.action === 'plus' && current < 99) input.value = current + 1;
    });
  });

  // Product form add to cart
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = this.querySelector('[name="id"]')?.value;
      const qty = parseInt(this.querySelector('[name="quantity"]')?.value || 1);
      if (variantId) {
        const btn = this.querySelector('.product-add-btn');
        const original = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        addToCart(variantId, qty).then(() => {
          btn.textContent = '✓ Added!';
          setTimeout(() => {
            btn.textContent = original;
            btn.disabled = false;
          }, 2000);
        });
      }
    });
  }

  // Product thumbnail gallery
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.querySelector('.product-main-img');
      if (mainImg && this.dataset.src) {
        mainImg.src = this.dataset.src;
        document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });

  // Close mobile menu on outside click
  document.addEventListener('click', function (e) {
    const nav = document.getElementById('mobile-nav');
    const hamburger = document.getElementById('hamburger');
    const header = document.querySelector('.site-header');
    if (nav && nav.classList.contains('open') && header && !header.contains(e.target)) {
      nav.classList.remove('open');
      hamburger?.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  // Close search modal on outside click
  const searchModal = document.getElementById('search-modal');
  if (searchModal) {
    searchModal.addEventListener('click', function (e) {
      if (e.target === this) this.classList.remove('active');
    });
  }

  // Sticky header shadow on scroll
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 2px 20px rgba(0,0,0,0.08)'
        : 'none';
    }, { passive: true });
  }

});
